import styled, { css } from 'styled-components/macro';
import { FileNameP } from '../../../../components/FileUploadStyles';
import { DefaultIcon } from '../../../../components/Icon';

export const ImportCsvDiv = styled.div`
  @media screen and (min-width: 768px) {
    margin-bottom: 80px;
  }
  @media screen and (min-width: 1024px) {
    margin-top: 25px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    flex-wrap: nowrap;
    max-width: 800px;
  }
  @media screen and (min-width: 1440px) {
    max-width: 1000px;
  }
`;

export const DownloadCsvItemDiv = styled.div`
  margin-top: 25px;
  @media screen and (max-width: 767px) {
    text-align: center;
  }

  @media screen and (min-width: 1024px) {
    width: 310px;
  }
  @media screen and (min-width: 1440px) {
    width: 337px;
  }
  span {
    text-decoration: underline;
    font-weight: 400;
  }
  img {
    width: 20px;
  }
`;

export const DownloadIconTextLinkDiv = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  :last-child {
    margin-left: 10px;
  }
  h5 {
    margin-left: 10px;
    color: ${props => props.theme.blue};
  }
  ${props =>
    props.reverseIcon &&
    css`
      flex-direction: row-reverse;
      justify-content: flex-end;
      h5 {
        margin-left: 0px;
        margin-right: 3px;
      }
    `}
  ${DefaultIcon} {
    height: 1rem;
    width: 1rem;
  }
  @media screen and (max-width: 767px) {
    justify-content: center;
  }
`;

export const UploadCsvFormDiv = styled.form`
  @media screen and (max-width: 767px) {
    margin-top: 40px;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    margin-top: 25px;
    width: 460px;
  }
  @media screen and (min-width: 1024px) {
    width: 450px;
    margin-right: 30px;
  }
  @media screen and (min-width: 1440px) {
    width: 477px;
    margin-right: 85px;
  }
  ${FileNameP} {
    word-break: break-word;
  }
`;

export const SuccessH4 = styled.h4`
  color: ${props => props.theme.green};
  margin-top: 24px;
  margin-bottom: 3px;
`;

export const IconTextLinkButton = styled.div`
  width: 90px;
  h6 {
    color: black;
  }
  display: flex;
  svg {
    margin-right: 5px;
    fill: ${props => props.theme.blue};
  }
  @media screen and (min-width: 768px) {
    width: 245px;
  }
  &:hover {
    h6 {
      cursor: pointer;
    }
  }
`;

export const TableTitleDiv = styled.div`
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
`;

export const DeleteAllDiv = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    margin: 25px 0px 15px;
  }
  span {
    color: ${props => props.theme.blue};
  }
`;

export const FailedMerchantsDiv = styled.div`
  @media screen and (max-width: 767px) {
    max-width: 425px;
    margin: 65px auto 0px;
  }
`;

export const StyledA = styled.a`
  font-weight: 400;
  color: black;
  text-decoration: underline;
`;
